import { render } from "./index.vue?vue&type=template&id=f3fb43f8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=f3fb43f8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f3fb43f8"

export default script